﻿import m from "mithril";
import FormUtilities from "../../shared/utilities/form_utilities";
import Requester from "../../shared/request";
import Gateway from "../../shared/app_settings";
import ModalManager from "../../shared/modal";
import Toasts from "../../shared/toasts";
import i18n from "../../shared/i18n/i18n";

let valid = true;
let userId, callback, saving, email, modalId;
const eLearningEmail = 'eLearningrequest@pegasus.net.au';

function saveEmail() {
    if (!valid) {
        Toasts.add("error", i18n.t("cant_save"), i18n.t("enter_valid_email"));
        return;
    }

    saving = true;
    Requester.post(Gateway.admin + "users/" + userId + "/email", {email: email})
        .then(function () {
            ModalManager.close(modalId);
            Toasts.add("success", "Email Updated", "");
            if (callback) {
                callback();
            }
        }).catch(function (error) {
        Toasts.add("error", i18n.t("error"), i18n.t(error.response.properties.errorCode));
    }).finally(function () {
        saving = false;
    });
}

const Modal_User_Edit_Email = {
    oninit: function(vnode) {
        userId = vnode.attrs.userId;
        callback = vnode.attrs.callback;
        email = vnode.attrs.email;
    },
    view: function () {
        return [
            m(".form-section  text-center", [
                m(".text-bold", i18n.t("important")),
                m("br"),
                i18n.t("edit_email_warning_1"),
                m("span.text-bold", ' ' + i18n.t("edit_email_warning_2")),
                m("br"),
                m("br"),
                i18n.t("edit_email_warning_3"),
                m("span", [m("a", {class: "hyperlink", target: "_blank", href: "mailto:" + eLearningEmail}, ' ' + eLearningEmail)]),//todo
                m("span", ' ' + i18n.t("edit_email_warning_4")),
                m("br"),
                m("br"),
                i18n.t("edit_email_warning_5"),
                m("br"),
                i18n.t("edit_email_warning_6"),
                m("br"),
                i18n.t("edit_email_warning_7"),
                m("br"),
                i18n.t("edit_email_warning_8"),
                m("br"),
                i18n.t("edit_email_warning_9"),
                m("br"),
                m("br"),
                m(".text-bold", i18n.t("edit_email_warning_10"))
            ]),
            m(".form-section", [
                m(".form-label", "Email"),
                m("input[type=text]", {
                    oninput: function () {
                        email = this.value;
                        valid = FormUtilities.validateEmail(this.value);
                    },
                    value: email
                })
            ]),
            m(".form-buttons", [
                saving ? m("button.btn-text no-click", ["Saving", m(".loading-dots")])
                : m("button", {onclick: saveEmail}, "Save")
            ])
        ];
    },
    setModalId: function(id) {
        modalId = id;
    }
};
export default Modal_User_Edit_Email;